var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legacy",staticStyle:{"background-color":"#333"}},[_c('embed',{staticStyle:{"width":"100%","height":"calc(100vh - 76px)","margin-top":"76px","display":"block","overflow":"auto"},attrs:{"src":"https://legacy.transplus.ca"}})])
}]

export { render, staticRenderFns }